import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Category from "@/views/Category";
import Product from "@/views/Product";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/category/:id',
    name: 'Category',
    props: true,
    component: Category
  },
  {
    path: '/product/:id',
    name: 'Product',
    props: true,
    component: Product
  },

]

const router = new VueRouter({
  mode: 'hash',
  base: '/',
  routes
})

export default router
